import _ from 'lodash'
import { ButtonGroup, Button } from 'reactstrap'

class RadioButtonGroup extends React.Component {
  state

  static defaultProps = {
    onChange: () => {},
    keyToGetValue: 'value',
    classNamePrefix: 'radio-btn',
    className: undefined,
    value: '',
    autoClassName: false,
  }

  constructor(props) {
    super(props)

    this.state = {
      selectedId: this.props.value,
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value || this.props.options !== nextProps.options) {
      this.setState({
        selectedId: nextProps.value,
      })
    }
  }

  selectButton(id, index) {
    this.props.onChange(id, index)
    this.setState({
      selectedId: id,
    })
  }

  generateClassName = (value) => {
    return this.props.autoClassName ? `${this.props.classNamePrefix}-${value.toLowerCase()}` : ''
  }

  setColorBtn = (isActive, option) => {
    if (isActive) return 'primary'
    else {
      if (!_.isUndefined(option.canSelectable)) return option.canSelectable ? 'default' : 'disabled'
      else return 'default'
    }
  }

  render() {
    const { className, options, keyToGetValue } = this.props
    const { selectedId } = this.state
    const _selectedId = typeof selectedId === 'object' ? selectedId.value : selectedId
    return (
      <ButtonGroup className={className}>
        {_.map(options, (option, index) => {
          const isActive = _selectedId === option[keyToGetValue]
          const optionClassName = this.generateClassName(option[keyToGetValue])
          const color = this.setColorBtn(isActive, option)
          return (
            <Button
              key={index}
              color={color}
              className={optionClassName}
              onClick={() => this.selectButton(option[keyToGetValue], index)}
              data-text={option.text}
              data-value={option[keyToGetValue]}
              disabled={_.isUndefined(option.canSelectable) ? false : !option.canSelectable}
            >
              {option.text}
            </Button>
          )
        })}
      </ButtonGroup>
    )
  }
}

export default RadioButtonGroup
